<template>
    <div class="navigator-suggestions">
        <button v-for="(item, index) in items" :key="index"
            class="navigator-suggestion-pill"
            @click="$emit('select', item)">
            {{ item }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'NavigatorSuggestions',
    props: {
        items: { type: Array, default: () => [] },
    },
    emits: ['select'],
};
</script>

<style scoped>
.navigator-suggestions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
}

.navigator-suggestion-pill {
    background: var(--nav-accent-soft, rgba(139, 92, 246, 0.08));
    border: 1px solid var(--nav-card-border, rgba(139, 92, 246, 0.2));
    border-radius: 20px;
    color: var(--nav-accent, #8b5cf6);
    font-size: 13px;
    padding: 8px 16px;
    cursor: pointer;
    transition: all 0.15s;
    font-family: 'Nunito', sans-serif;
}

.navigator-suggestion-pill:hover {
    background: var(--nav-hover, rgba(139, 92, 246, 0.15));
    border-color: var(--nav-accent, #8b5cf6);
}
</style>
